module.exports = __webpack_public_path__ + "img/group@3x.3499f2a6.jpg";